import { lazyRouteComponent } from "@tanstack/react-router";
import { TableProperties } from "lucide-react";

import type { PageDef } from "@/app/registry";

import { parsePremiumSearch } from "./premium";

export const VIEWS = ["ltp_oi", "depth", "flow", "greeks"] as const;
/** Strikes each side of the money, as on Kite and Angel; "all" = every listed strike. */
export const RANGES = ["10", "20", "all"] as const;

export interface ChainSearch {
  /** Underlying symbol, e.g. NIFTY, RELIANCE. */
  underlying: string;
  /** ISO expiry date; absent means the nearest. */
  expiry?: string;
  view: (typeof VIEWS)[number];
  range: (typeof RANGES)[number];
}

export function parseChainSearch(s: Record<string, unknown>): ChainSearch {
  const u = typeof s.underlying === "string" && /^[A-Za-z0-9&_-]{1,30}$/.test(s.underlying) ? s.underlying : "NIFTY";
  const e = typeof s.expiry === "string" && /^\d{4}-\d{2}-\d{2}$/.test(s.expiry) ? s.expiry : undefined;
  const view = VIEWS.includes(s.view as (typeof VIEWS)[number]) ? (s.view as ChainSearch["view"]) : "ltp_oi";
  const range = RANGES.includes(s.range as (typeof RANGES)[number]) ? (s.range as ChainSearch["range"]) : "20";
  return { underlying: u.toUpperCase(), ...(e ? { expiry: e } : {}), view, range };
}

export const pages: PageDef[] = [
  {
    path: "/app/option-chain",
    proOnly: true,
    title: "Option chain",
    component: lazyRouteComponent(() => import("./OptionChainPage"), "OptionChainPage"),
    nav: { label: "Option chain", icon: TableProperties, group: "Premium", order: 20 },
    validateSearch: parseChainSearch,
  },
  {
    // one contract's premium with moving averages, opened from a call's or put's LTP
    path: "/app/option-chain/premium",
    proOnly: true,
    title: "Option premium chart",
    component: lazyRouteComponent(() => import("./PremiumPage"), "PremiumPage"),
    validateSearch: parsePremiumSearch,
  },
];
